/* ============================================================
   Stucbedrijf Cramer — site interactions
   Nav, dropdown, mobile menu, hero slider, reveals, counters
   ============================================================ */
(function () {
  'use strict';

  var header = document.getElementById('siteHeader');
  var hamburger = document.getElementById('hamburger');
  var overlay = document.getElementById('overlayMenu');
  var dropdown = document.querySelector('.dropdown');
  var dropToggle = document.querySelector('.dropdown__toggle');

  // ---- Header background on scroll ----
  function onScroll() {
    if (window.scrollY > 30) header.classList.add('is-scrolled');
    else header.classList.remove('is-scrolled');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ---- Dropdown (Diensten) ----
  if (dropToggle) {
    dropToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = dropdown.classList.toggle('is-open');
      dropToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function () {
      dropdown.classList.remove('is-open');
      dropToggle.setAttribute('aria-expanded', 'false');
    });
  }

  // ---- Mobile / full-screen menu ----
  function closeMenu() {
    hamburger.classList.remove('is-active');
    overlay.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  hamburger.addEventListener('click', function () {
    var open = hamburger.classList.toggle('is-active');
    overlay.classList.toggle('is-open', open);
    hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
    overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  });
  overlay.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', closeMenu);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  // ---- Hero slider ----
  var slides = document.querySelectorAll('.hero__slide');
  var slideNum = document.getElementById('slideNum');
  var current = 0;
  var timer;

  function goTo(i) {
    current = (i + slides.length) % slides.length;
    slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
    if (slideNum) slideNum.textContent = current + 1;
  }
  function next() { goTo(current + 1); }
  function startAuto() { stopAuto(); timer = setInterval(next, 6000); }
  function stopAuto() { if (timer) clearInterval(timer); }

  var heroPrev = document.getElementById('heroPrev');
  var heroNext = document.getElementById('heroNext');
  if (heroPrev) heroPrev.addEventListener('click', function () { goTo(current - 1); startAuto(); });
  if (heroNext) heroNext.addEventListener('click', function () { goTo(current + 1); startAuto(); });
  if (slides.length > 1) startAuto();

  // ---- Scroll reveal ----
  var revealSelectors = [
    '.welkom__intro', '.welkom__body', '.section-head', '.dienst',
    '.stap', '.project', '.stat', '.agenda__calendar', '.agenda__panel',
    '.contact__intro', '.contact__form'
  ];
  var revealEls = [];
  revealSelectors.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (n) { n.classList.add('reveal'); revealEls.push(n); });
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
          if (entry.target.classList.contains('stat')) animateCount(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (n) { io.observe(n); });
  } else {
    revealEls.forEach(function (n) { n.classList.add('is-visible'); });
    document.querySelectorAll('.stat').forEach(animateCount);
  }

  // ---- Stat counters ----
  function animateCount(statEl) {
    var numEl = statEl.querySelector('.stat__num');
    if (!numEl || numEl.dataset.done) return;
    numEl.dataset.done = '1';
    var target = parseInt(numEl.getAttribute('data-count'), 10) || 0;
    var dur = 1400, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      numEl.textContent = Math.round(target * eased);
      if (p < 1) requestAnimationFrame(step);
      else numEl.textContent = target;
    }
    requestAnimationFrame(step);
  }

  // ---- Contact form (demo) ----
  var contactForm = document.getElementById('contactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var fb = document.getElementById('contactFeedback');
      if (fb) fb.hidden = false;
      contactForm.reset();
    });
  }

  // ---- Footer year ----
  var year = document.getElementById('year');
  if (year) year.textContent = new Date().getFullYear();

  // ---- Smooth anchor offset for fixed header ----
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

})();
